import { render } from "./BaseView.vue?vue&type=template&id=77be899a&scoped=true"
import script from "./BaseView.vue?vue&type=script&lang=js"
export * from "./BaseView.vue?vue&type=script&lang=js"

import "./BaseView.vue?vue&type=style&index=0&id=77be899a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77be899a"]])

export default __exports__